
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 140 140"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M83.417 71.05a1.4 1.4 0 010-2.042l54.016-54.075a8.692 8.692 0 000-12.366 8.808 8.808 0 00-12.366 0L71.05 56.583a1.458 1.458 0 01-2.1 0L14.933 2.567a8.808 8.808 0 00-12.366 0 8.692 8.692 0 000 12.366l54.016 54.075a1.4 1.4 0 010 2.042L2.567 125.067a8.692 8.692 0 000 12.366 8.808 8.808 0 0012.366 0L68.95 83.417a1.458 1.458 0 012.1 0l54.017 54.016a8.808 8.808 0 0012.366 0 8.692 8.692 0 000-12.366z","fill":"currentColor"}})])
          )
        }
      }
    